import visionProSolid from '@/assets/device-icons/vision-pro-solid.svg';

interface VisionProSolidIconProps {
  className?: string;
}

export const VisionProSolidIcon = ({ className = "h-5 w-5" }: VisionProSolidIconProps) => {
  return (
    <img 
      src={visionProSolid} 
      alt="Vision Pro" 
      className={className}
    />
  );
};
